<template>
  <el-radio-group v-model="changeValue" v-bind="{ ...item }" style="width: 100%" v-removeAriaHidden>
    <template v-for="(option, index) in getOptions()">
      <div
        v-if="!isHideQuota(option)"
        :key="option.value"
        class="show-vote"
        :class="[
          item.config.inline ? 'inline-block' : 'block',
          isChecked(option.value) ? 'checked' : '',
          item.disabled ? 'disabled' : '',
          curSelectedOption === option.value ? 'highWeight' : ''
        ]"
      >
        <div class="drawing-list picture" v-if="mode === 'design'">
          <upload-img
            :key="'picture' + option.value"
            :show-file-list="false"
            listType="text"
            :limitCount="100"
            @uploadSuccess="(res) => uploadLogoHandle(res, index)"
          >
            <template slot="btn">
              <span class="drawing-item__picture">
                <i class="el-icon-picture-outline" />
              </span>
            </template>
          </upload-img>
        </div>
        <el-tooltip
          offset="62"
          :disabled="changeValue === option.value || mode !== 'design'"
          effect="dark"
          content="设为默认选中"
          placement="top-start"
        >
          <el-radio
            :disabled="option.quotaSetting && getSurplusQuota(option) <= 0"
            :label="option.value"
            @click.native.prevent="handleClick(option)"
          >
            <span v-if="getSurplusQuota(option) <= 0 && item.config.quotaBlankWarning">{{
              item.config.quotaBlankWarning
            }}</span>
            <span v-else>{{ option.label }}</span>
            <span class="text-muted" v-if="showQuota(option)">(余{{ getSurplusQuota(option) }})</span>
          </el-radio>
        </el-tooltip>
        <div class="option_desc_input" v-if="mode === 'design' || option.description">
          <el-input v-if="mode === 'design'" v-model="option.description" placeholder="选项描述" />
          <span v-else-if="option.description" class="option_desc">{{ option.description }}</span>
        </div>

        <div class="vote-wrap">
          <template v-if="(option.value === 0 || option.isFill) && isChecked(option.value)">
            <div class="extension_box">
              <span v-if="option.required" class="required_icon"></span>
              <el-form-item
                class="extension_item"
                :prop="`${item.vModel}extension_${option.value}`"
                label=""
                :rules="{
                  required: option.required && item.isFieldShow,
                  message: '选项后内容为必填项',
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="option.inputValue"
                  @change="(val) => optionExtensionChange(val, option.value)"
                  v-if="option.fillContent"
                  style="width: 100%"
                  :popper-append-to-body="false"
                  @focus="selectFocus(option.value)"
                >
                  <el-option
                    :value="opt.label"
                    v-for="opt in option.fillContentJson"
                    :key="opt.value"
                    :label="opt.label"
                  ></el-option>
                </el-select>
                <el-input
                  v-else
                  v-model="option.inputValue"
                  class="other-input"
                  @input="(val) => optionExtensionChange(val, option.value)"
                />
              </el-form-item>
            </div>
          </template>

          <template v-if="option.optionImgUrl">
            <upload-img
              v-if="mode === 'design'"
              :alreadyFile="option.optionImgUrl"
              listType="picture-card"
              @removeSuccess="removeBgImgHandle(index)"
            >
            </upload-img>
            <el-image
              v-else
              :preview-src-list="[option.optionImgUrl]"
              :src="option.optionImgUrl"
              class="image"
              fit="contain"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" />
              </div>
            </el-image>
          </template>

          <vote
            :value="option.value"
            :vote-list="voteList"
            :total-vote="totalVote"
            v-if="item.config.showVoteResult"
          ></vote>
        </div>
      </div>
    </template>
    <!--    <template v-else>
          <span v-for="(option) in getOptions()" :key="option.value">
            <el-radio-button
              :label="option.value"
              :style="{display: item.config.inline ? 'inline-block' : 'block'}"
            >
              {{ option.label }}
            </el-radio-button>
            <el-input v-if="option.value===0" v-model="otherInputValue" style="margin-left: 25px" class="other-input"
                      size="mini"
            />
          </span>
        </template>-->
  </el-radio-group>
</template>

<script>
import Vote from '../TVote/vote'
import mixin from '../mixin'
import VoteMixin from '../TVote/VoteMixin'
import OptionQuotaMixin from '../mixins/OptionQuotaMixin'
import UploadImg from '@/components/Upload/UploadImg.vue'

export default {
  name: 'TRadioGroup',
  mixins: [mixin, VoteMixin, OptionQuotaMixin],
  props: ['models'],
  components: {
    Vote,
    UploadImg
  },
  data() {
    return {
      oldValue: null,
      otherInputValue: '',
      optionExtension: '',
      disabled: false
    }
  },
  // watch: {
  //   otherInputValue: {
  //     deep: true,
  //     handler(val) {
  //       this.models[`${this.item.vModel}${this.changeValue === 0 ? 'other' : 'extension_' + this.changeValue}`] = val
  //       this.$emit('other-input-change', this.changeValue, this.item)
  //     }
  //   }
  // },
  mounted() {
    if (this.models) {
      this.otherInputValue = this.models[`${this.item.vModel}other`]
    }
  },
  methods: {
    isChecked(val) {
      return val === this.changeValue
    },
    handleClick(option) {
      console.log('option', option)
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 200)
      if (this.item.disabled) {
        return
      }
      if (option.quotaSetting && this.getSurplusQuota(option) <= 0) {
        return
      }
      option.value === this.changeValue ? (this.changeValue = null) : (this.changeValue = option.value)
      this.handleVote(this.changeValue)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/form/home.scss';
.el-radio {
  height: auto;
  padding: 5px 10px;
  // line-height: 28px !important;
}
::v-deep {
  .item {
    top: 50% !important;
  }
  .el-radio {
    display: flex;

    // .el-radio__input {
    //   line-height: 32px !important;
    // }

    // .el-radio__label {
    //   line-height: 28px !important;
    // }
  }
}

.block {
  margin-bottom: 10px;

  .el-radio {
    width: 100%;
  }

  .other-input {
    margin-top: 10px;
  }
}
.el-radio-group {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
}

.inline-block {
  display: inline-block;
  // margin-bottom: 10px;
  // margin-right: 10px;
  vertical-align: top;

  .el-radio {
    width: 100%;
  }

  .other-input {
    margin-top: 10px;
  }
}

.inline-block.show-vote {
  width: 100%;
}

.radio-icon-wrap {
  display: inline-block;
  margin-left: -8px; /* 让tooltip更靠左边 */
}

.show-vote {
  border-bottom: 1px solid #dcdfe6;
  padding: 10px 0;
  color: #979797;
  position: relative;
  .vote-wrap {
    padding: 5px 10px;
    position: relative;
  }

  .vote-wrap:empty {
    padding: 0;
  }

  .other-input {
    margin-top: 0;
  }
  .picture {
    top: 10px;
    .drawing-item__picture {
      display: inline-block;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
      color: #1890ff;
    }
  }
  .extension_box {
    display: flex;
    .required_icon {
      margin-right: 4px;
      font-size: 12px;
      &::before {
        content: '*';
        color: #f56c6c;
      }
    }
    .extension_item {
      flex-shrink: 0;
      width: 90%;

      .option-content {
        padding-right: 12px;
      }
    }
  }
  .image {
    width: 130px;
    height: 130px;
  }
}

[class~='show-vote']:last-of-type {
  border: none;
}

.checked {
  border-color: #1890ff;
}

.checked.disabled {
  border-color: #dcdfe6;
}

@media screen and (max-width: 414px) {
  .inline-block.show-vote:nth-child(even) {
    margin-right: 0;
  }
}

::v-deep {
  .el-radio__label {
    width: 90% !important;
    text-overflow: ellipsis;
    white-space: normal;
    word-wrap: break-word;
    display: inline-block;
    vertical-align: middle;
  }
  .option_desc_input {
    min-height: 18px;
    line-height: 1;
    margin-bottom: 5px;
    .el-input__inner,
    .option_desc {
      color: #938d8d;
      border: none;
      background: transparent;
      padding: 0px;
      position: relative;
      z-index: 1;
      padding: 0px 0px 0 34px;
      font-size: 16px;
      line-height: 1;
      opacity: 0.7;
      display: inline-block;
      width: 90%;
      word-break: break-all;
    }
  }
}
// ::v-deep .el-radio__input.is-checked {
//   .el-radio__inner{
//     &::after {  background-color: #FFD027; }
//       border: 2px solid #2F394E;
//       background: #FFD027;
//   }

// }
// ::v-deep .el-radio__input.is-checked + .el-radio__label{
//    font-size: 16px;
//     font-family: PingFangSC-Semibold, PingFang SC;
//     font-weight: 600;
//     color: #2F394E;
// }
</style>
